<script>
    import { onMount } from "svelte";
    import JobCard_down from "@buhl_ui/buhl_core/bc_news/joboffercards/lib/jobcard/JobCard_down.svelte";
    import JobCard_up from "@buhl_ui/buhl_core/bc_news/joboffercards/lib/jobcard/JobCard_up.svelte";

    let jobCards = $state([]);
    let isLoading = $state(false);
    let apiMessage = $state("");
    let headline = $state("Aktuelle Jobs");

    let latitude = $state("");
    let longitude = $state("");
    let errorMessage = $state("");
    let locationAllowed = $state(false);
    let locationDenied = $state(false);
    let isRegional = $state(false);
    let city = $state("");

    let { layout, projectName } = $props();

    onMount(() => {
        const pathname = window.location.pathname;
        if (pathname.includes("/regional/")) {
            isRegional = true;
            city = pathname.split("regional/")[1].split("/")[0];
        } else {
            isRegional = false;
        }

        // Schon entschieden?
        const storedDecision = localStorage.getItem("locationDecision");
        const storedLat = localStorage.getItem("latitude");
        const storedLng = localStorage.getItem("longitude");

        if (storedLat && storedLng) {
            latitude = storedLat;
            longitude = storedLng;
        }

        if (storedDecision === "allowed") {
            locationAllowed = true;
            loadJobCards();
            return;
        }
        if (storedDecision === "denied") {
            locationDenied = true;
            loadJobCards();
            return;
        }
        if (!isRegional) {
            const userAccepted = confirm("Wir möchten auf Ihren Standort zugreifen, um hier die passende Stellenanzeigen in Ihrer Nähe anzuzeigen. Stimmen Sie zu?");
            if (!userAccepted) {
                errorMessage = "Sie haben den Standortzugriff abgelehnt.";
                locationDenied = true;
                localStorage.setItem("locationDecision", "denied");
                loadJobCards();
                return;
            }
            if (userAccepted) {
                locationAllowed = true;
                localStorage.setItem("locationDecision", "allowed");
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(success, error);
            } else {
                errorMessage = "Geolocation not supported in this browser.";
                locationDenied = true;
                localStorage.setItem("locationDecision", "denied");
                loadJobCards();
            }
        } else {
            loadJobCards();
        }
    });

    function success(position) {
        latitude = position.coords.latitude;
        longitude = position.coords.longitude;

        localStorage.setItem("latitude", latitude);
        localStorage.setItem("longitude", longitude);
        localStorage.setItem("locationDecision", "allowed");
        locationAllowed = true;
        loadJobCards();
    }

    function error() {
        errorMessage = "Sorry, no position available.";
        locationDenied = true;
        localStorage.setItem("locationDecision", "denied");
        loadJobCards();
    }

    // API-Call
    async function loadJobCards() {
        isLoading = true;
        apiMessage = "";
        jobCards = [];

        try {
            let url = `/api/frontend/job_offer_cards/?radius=25&limit=4&pro=${projectName}`;

            // Standort anhängen
            if (locationAllowed && latitude && longitude && !isRegional) {
                url += `&lat=${latitude}&lng=${longitude}`;
                headline = "Jobs aus Ihrer Region";
            }
            if (isRegional) {
                url += `&reg=${city}`;
                headline = "Jobs aus Ihrer Region";
            }

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            const data = await response.json();

            if (response.ok) {
                jobCards = data.results || [];
                apiMessage = `Geladen: ${jobCards.length} Angebote`;
            } else {
                apiMessage = data.error || "Fehler beim Laden der Jobangebote.";
            }
        } catch (error) {
            apiMessage = "Netzwerkfehler: " + error.message;
            console.error("Fehler beim Laden der Jobangebote:", error);
        } finally {
            isLoading = false;
            // localStorage.removeItem("locationDecision");
        }
    }
</script>

{#if layout == "small"}
    <JobCard_up {jobCards} {headline} />
{:else}
    <JobCard_down {jobCards} {headline} />
{/if}
